import React from 'react';
import PropTypes from 'prop-types';
import { materialPropType } from 'types/PDPTypes';
import SidebarModal from 'components/consumer/SidebarModal';

import usePDPPhotos from 'data-hooks/usePDPPhotos';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import PDPFabricUpChargeModalUI from './PDPFabricUpChargeModalUI';

const PDPFabricUpChargeModal = ({
  onClose,
  orderId,
  cartItem,
  orderInfo,
  updateOrder,
  selectedMaterial,
  editOrderErrorMessage,
  orderUpChargeSummaryData,
}) => {
  const { data: photosData, error: photosError } = usePDPPhotos();

  if (photosError) {
    return null;
  }

  return (
    <SidebarModal isOpen onClose={onClose}>
      <PDPFabricUpChargeModalUI
        cartItem={cartItem}
        errorMessage={editOrderErrorMessage}
        imgSrc={photosData?.configurationPhotos?.[0]?.src}
        isInSidebarModal
        orderId={orderId}
        orderInfo={orderInfo}
        paymentMethods={orderUpChargeSummaryData?.methods}
        selectedMaterial={selectedMaterial}
        upChargeSummary={orderUpChargeSummaryData?.summary}
        updateOrder={updateOrder}
      />
    </SidebarModal>
  );
};

PDPFabricUpChargeModal.propTypes = {
  onClose: PropTypes.func,
  orderId: PropTypes.string,
  cartItem: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
    cart_id: PropTypes.string,
    quantity: PropTypes.string,
  }),
  orderInfo: PropTypes.shape({
    shipping: PropTypes.shape({
      address_first_name: PropTypes.string,
      address_last_name: PropTypes.string,
    }),
    customer: PropTypes.shape({
      customer_email: PropTypes.string,
    }),
  }),
  updateOrder: PropTypes.func,
  selectedMaterial: materialPropType,
  editOrderErrorMessage: PropTypes.string,
  orderUpChargeSummaryData: PropTypes.shape({
    methods: PropTypes.array,
    summary: PropTypes.object,
  }),
};

export default withBrowserOnly(PDPFabricUpChargeModal);
